window.addEventListener('DOMContentLoaded', () => {
    if ($('.tabs').length) {
    var tabsLink = document.querySelectorAll(".tabslink");
    var tabsContent = document.querySelectorAll(".tabscontent");
    var tabsImage = document.querySelectorAll(".tabsimage");

    tabsLink.forEach(function (el) {
      el.addEventListener("click", openTabs);
    });
    tabsLink[0].click();
  }

  function openTabs(el) {
    var btnTarget = el.currentTarget;
    var section = btnTarget.dataset.section;

    tabsContent.forEach(function (el) {
      el.classList.remove("active");
    });

    tabsLink.forEach(function (el) {
      el.classList.remove("active");
    });

    tabsImage.forEach(function (el) {
      el.classList.remove("active");
    });

    document.querySelector("#" + section).classList.add("active");

    document.querySelector("#image-" + section).classList.add("active");

    btnTarget.classList.add("active");
  }
});